export const CLOSE_DIALOG_INVITE_USER = 'lumahealth/DialogInviteUser/CLOSE_DIALOG_INVITE_USER';

export const DIALOG_INVITE_USER_FORM = 'dialogInviteUserForm';

export const INVITE_USER = 'lumahealth/DialogInviteUser/INVITE_USER';
export const INVITE_USER_SUCCESS = 'lumahealth/DialogInviteUser/INVITE_USER_SUCCESS';
export const INVITE_USER_ERROR = 'lumahealth/DialogInviteUser/INVITE_USER_ERROR';

export const OPEN_DIALOG_INVITE_USER = 'lumahealth/DialogInviteUser/OPEN_DIALOG_INVITE_USER';
